import { inject, Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { PortalOverviewSandbox } from '@common/sandboxes/portal-overview.sandbox.service';
import {
    Combine,
    GenerativeMetadataGuard,
    Profile,
    ProfileDataService,
    RecordRestrictions,
    Restriction
} from '@stylehaven/components';

@Injectable({ providedIn: 'root' })
export class PublishedSandbox extends PortalOverviewSandbox {
    private readonly generativeMetadataGuard: GenerativeMetadataGuard = inject(GenerativeMetadataGuard);
    private readonly profileDataService: ProfileDataService = inject(ProfileDataService);

    public getRestrictions(): Observable<Restriction> {
        return this.getGeolocationRestriction().pipe(
            map(geolocationRestriction =>
                Combine.And(
                    this.zoneRestrictions.regularRecordTypesZone(),
                    geolocationRestriction,
                    RecordRestrictions.publishedStatusRestriction()
                )
            )
        );
    }

    public getAiProfile(): Observable<Profile | undefined> {
        const aiProfileStream$: Observable<Profile> = this.getCurrentUser().pipe(
            switchMap(user => this.profileDataService.getAiProfile(user.Organisation.Id))
        );

        return this.generativeMetadataGuard
            .hasAccess()
            .pipe(switchMap(hasAccess => (hasAccess ? aiProfileStream$ : of(undefined))));
    }
}
